import cookies from 'js-cookie';
import { requester } from '../utils';

export const loginOrRegister = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/loginOrRegister`,
        method: 'POST',
        withAuth: false,
        data,
      })
      .then((result) => {
        let currentDate = new Date();
        let currentTime = currentDate.setSeconds(
          currentDate.getSeconds() + result.payload.timer,
        );
        cookies.set('login-timer', currentTime);
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('login or register error', err);
        reject(err);
      });
  });
};

export const Register = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/register`,
        method: 'POST',
        withAuth: false,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('register error', err);
        reject(err);
      });
  });
};

export const verificationCodeBySMS = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/newVerificationCodeBySMS`,
        method: 'POST',
        withAuth: false,
        data,
      })
      .then((result) => {
        let currentDate = new Date();
        let currentTime = currentDate.setSeconds(
          currentDate.getSeconds() + result.payload.timer,
        );
        cookies.set('login-timer', currentTime);
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('verification code error', err);
        reject(err);
      });
  });
};

export const loginByPassword = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/loginByPassword`,
        method: 'POST',
        withAuth: false,
        data,
      })
      .then((result) => {
        cookies.set('auth-token', result.payload.authToken);
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('login by password error', err);
        reject(err);
      });
  });
};

export const loginByVerifyPhoneNumber = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/verifyPhoneNumber`,
        method: 'POST',
        withAuth: false,
        data,
      })
      .then((result) => {
        cookies.set('auth-token', result.payload.authToken);
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('login by verify phone number error', err);
        reject(err);
      });
  });
};

export const setPassword = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/setPassword`,
        method: 'PUT',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('set password error', err);
        reject(err);
      });
  });
};

export const changePassword = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/changePassword`,
        method: 'PUT',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('change password error', err);
        reject(err);
      });
  });
};

export const forgetPassword = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/forgetPassword`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('forget password error', err);
        reject(err);
      });
  });
};
